// extracted by mini-css-extract-plugin
export default {"widget":"styles_widget__6caue","leftSection":"styles_leftSection__1aDKe","rightSection":"styles_rightSection__dnfDs","row":"styles_row__V5JAl"};